
























import app from "@/app";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { SXSurvey, SXQuestion } from "@/gobl.bundle";

@Component
export default class WSurveyAnswerView extends BaseComponent {
	@Prop({ type: SXSurvey, required: true })
	survey!: SXSurvey;

	get answerId() {
		return app.store.routeContext.getToken("answer_id");
	}

	get answer() {
		return app.services.answers.identify(this.answerId);
	}

	get user() {
		return app.services.users.identify(this.answer!.user_id);
	}

	get questionsAnswered() {
		let x = this,
			list = app.services.surveys.surveyQuestions(this.survey);

		return app.services.questions.select(list, function(q) {
			return x.answerDecoded[q.id];
		});
	}

	get answerDecoded() {
		let dec = this.ux_custom_data(this.answer!.value, {});
		return dec.answers || {};
	}

	getAnswer(q: SXQuestion) {
		return this.answerDecoded[q.id];
	}
}
